<template>
  <v-row
    class="px-3"
    align="center"
    :justify="needsGap ? 'space-between' : 'start'"
    :class="columnView ? 'd-flex flex-column' : ''"
  >
    <v-col :cols="$vuetify.breakpoint.smAndDown ? 6 : (columnView ? 12 : 3)" class="pa-0">
      <v-btn
        v-if="clickBoth"
        class="font-weight-bold text-h6 mb-1 pr-0 text-capitalize unfade"
        plain
        text
        x-large
        @click="$emit(`${secondMethod}`)"
      >
        {{ fieldLabel }}
      </v-btn>
      <p
        v-else
        :class="`${
          (textConfigs && textConfigs.label)
            ? textConfigs.label
            : 'text-h6 fontGrey--text font-weight-medium'
        } `"
        class="text-right mb-0"
      >
        {{ fieldLabel }}
      </p>
    </v-col>
    <v-col class="pa-0" :cols="$vuetify.breakpoint.smAndDown ? 6 : (needsGap ? 5 : '')">
      <div v-if="multiple && fieldValue.length <= 4">
        <v-row>

          <v-btn
          v-for="(field, i) in fieldValue"
          :key="i"
          class="font-weight-bold text-h6 mb-1  text-capitalize unfade"
          :class="`${
            textConfigs
            ? textConfigs.other : (colorAccent ? `${colorAccent}--text` : 'fontDarkGrey--text px-2')
          } `"
          plain
          text
          :x-large="$vuetify.breakpoint.smAndDown ? false : true"
          @click="$emit(`${method}`, field)"
          >
            {{ formatPhone ? formated(field) : field }}
          </v-btn>
        </v-row>
      </div>
      <v-row v-if="multiple && fieldValue.length > 4" align="baseline">
        <v-col cols="4" md="3">
          <PhoneNumberSelect :displayFirst="userMainCid" />
        </v-col>
        <!-- <v-col cols="1">
          <v-btn icon text plain>
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </v-col> -->
      </v-row>
      <!-- :class="colorAccent ? `${colorAccent}--text` : 'fontDarkGrey--text'" -->
      <v-btn
      v-if="!multiple"
      class="font-weight-bold text-h6 mb-1 px-2 text-capitalize unfade"
        :class="`${
          textConfigs
            ? textConfigs.other : (colorAccent ? `${colorAccent}--text` : 'fontDarkGrey--text')
          } `"
        plain
        text
        x-large
        @click="$emit(`${method}`)"
        >
        <!-- : 'font-weight-bold text-h6 mb-1 px-2 text-capitalize unfade' -->
        <span v-if="applyMask" dir="ltr">
          {{ maskSimDisplay(fieldValue) }}
        </span>
        <span v-else>
          {{ formatPhone ? formated(fieldValue) : fieldValue }}
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import chunk from "lodash/chunk";
import join from "lodash/join";
import map from "lodash/map";

export default {
  name: "InfoRowClickable",
  components: {
    PhoneNumberSelect: () =>
      import("@/components/CommonComponents/Selects/PhoneNumberSelect"),
  },
  props: {
    fieldLabel: {
      type: String,
      required: true,
      default: "",
    },
    fieldValue: {
      type: [String, Boolean, Number, Array],
      required: false,
      default: "",
    },
    colorAccent: {
      type: String,
      required: false,
    },
    method: {
      type: String,
      required: false,
    },
    applyMask: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    formatPhone: {
      type: Boolean,
      required: false,
      default: false,
    },
    needsGap: {
      type: Boolean,
      required: false,
      default: false,
    },
    columnView: {
      type: Boolean,
      required: false,
      default: false,
    },
    textConfigs: {
      type: Object,
      required: false,
    },
    clickBoth: {
      type: Boolean,
      required: false,
      default: false,
    },
    secondMethod: {
      type: String,
      required: false,
    },
    userMainCid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.formatPhone;
  },
  methods: {
    maskSimDisplay(simString) {
      let chunks = chunk(simString, 5);
      let arr = map(chunks, (el) => {
        return join(el, "");
      });
      return join(arr, " ");
    },
    formated(stringNum) {
      return this.$options.filters.formatedPhone(stringNum);
    },
  },
};
</script>

<style lang="sass" scoped>
.v-input--selection-controls
  margin-top: 0px !important

.unfade .v-btn__content
    opacity: 0.9 !important
</style>
